import styled from "@emotion/styled";
import { ProgressBar, Label } from "react-aria-components";
import {
  MDSProgressBarColor,
  MDSProgressBarDirection,
  MDSProgressBarProps,
  MDSProgressBarSize,
} from "./progress-bar.types";

export const StyledProgressBarContainer = styled(ProgressBar)<MDSProgressBarProps>`
  display: grid;
  grid-template-areas:
    "label value"
    "bar bar";
  grid-template-columns: 1fr auto;
  gap: 8px;
  width: 100%;

  &:not([aria-valuenow]) {
    .progress-fill {
      width: 25%;
      border-radius: inherit;
      animation: ${({ direction = "ltr" }) =>
          direction === "rtl" ? "indeterminate-rtl" : "indeterminate"}
        2s infinite ease-in-out;
      will-change: transform;
    }
  }

  @keyframes indeterminate {
    0% {
      transform: translateX(-100%);
    }
    100% {
      transform: translateX(500%);
    }
  }

  @keyframes indeterminate-rtl {
    0% {
      transform: translateX(100%);
    }
    100% {
      transform: translateX(-500%);
    }
  }
`;

export const StyledLabel = styled(Label)`
  grid-area: label;
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.grey.x600};
`;

export const StyledValueLabel = styled.span`
  grid-area: value;
  font-size: ${({ theme }) => theme.fontSizes.small};
  font-weight: ${({ theme }) => theme.fontWeights.medium};
  color: ${({ theme }) => theme.colors.grey.x600};
`;

export const StyledProgressTrack = styled.div<{
  size?: MDSProgressBarSize;
  direction?: MDSProgressBarDirection;
  rounded?: boolean;
  $color?: MDSProgressBarColor;
}>`
  grid-area: bar;
  position: relative;
  background-color: ${({ theme, $color }) => {
    switch ($color) {
      case "emphasis":
        return theme.colors.background.button.emphasisLight.default;
      default:
        return theme.colors.grey.x200;
    }
  }};
  border-radius: ${({ theme, rounded }) =>
    rounded ? theme.borderRadius.max : theme.borderRadius.maximum};
  overflow: hidden;
  direction: ${({ direction = "ltr" }) => direction};
  height: ${({ size }) => {
    switch (size) {
      case "small":
        return "2px";
      case "large":
        return "8px";
      case "xlarge":
        return "12px";
      default:
        return "4px";
    }
  }};
`;

export const StyledProgressFill = styled.div<{
  color?: MDSProgressBarColor;
  percentage: number;
  direction?: "ltr" | "rtl";
  isAnimating?: boolean;
  rounded?: boolean;
}>`
  height: 100%;
  width: ${({ percentage }) => percentage}%;
  border-radius: inherit;
  transition: ${({ isAnimating }) => (isAnimating ? "none" : "width 0.3s ease-in-out")};
  background-color: ${({ theme, color }) => {
    switch (color) {
      case "success":
        return theme.colors.green.x500;
      case "primary":
        return theme.colors.primary.x500;
      case "emphasis":
        return theme.colors.background.button.emphasis.default;
      case "brand":
        return theme.colors.icon.brand;
      case "danger":
        return theme.colors.icon.danger;
      default:
        return theme.colors.grey.x600;
    }
  }};
`;
